// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner__nNOXV","content":"banner_content__jxVRf","welcome":"banner_welcome__L_fCR","lg_brandname":"banner_lg_brandname__N0Som","ip":"banner_ip__Q6llf"};